import React, { useContext } from "react"
import { Navigate } from "react-router-dom"
import { getUser } from "../../utils/auth"

import AppContext from "../../utils/context"
import { isNull } from "../../utils/validation"

const ProtectedPage = ({ element: Element, roles, usertype, ...routeProps }) => {
  const appContext = useContext(AppContext)

  const user = getUser()
  if (isNull(user)) {
    appContext.setUser(null)
    return <Navigate to="/login" />
  }

  if ((roles && roles.includes(appContext.user?.role)) || (usertype && appContext.user?.usertype === usertype)) {
    return <Navigate to="/unauthorized" />
  }

  return <Element {...routeProps} />
}

export default ProtectedPage
